// /** Create the cookie
//  *
//  * @param {string} cname - the name of the cookie
//  * @param {boolean} cvalue - the value of the cookie
//  * @param {number} exdays - how long the cookie should exist
//  */
const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = exdays === null ? '' : 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
}

// /**
//  * Read the cookie
//  *
//  * @param {string} cname - the name of the cookie
//  */
const getCookie = (cname) => {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  let c = '';
  for (let i = 0; i < ca.length; i++) {
    c = ca[i].trim();
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return '';
}

// /**
//  * Read the cookie value
//  *
//  * @param {string} cname - the value of the cookie
//  */
const getCookieValue = (cname) => {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  let c = '';
  for (let i = 0; i < ca.length; i++) {
    c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      const cv = c.split('=');
      return cv[1];
    }
  }
  return '';
}

// /**
//  * Delete the cookie
//  *
//  * @param {string} cname - the name of the cookie
//  */
const eraseCookie = (cname) => {
  setCookie(cname, '', -1);
}

export {setCookie, getCookie, getCookieValue, eraseCookie};
